var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCheckGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5C3.74 1.5 1.5 3.74 1.5 6.5C1.5 9.26 3.74 11.5 6.5 11.5C9.26 11.5 11.5 9.26 11.5 6.5C11.5 3.74 9.26 1.5 6.5 1.5ZM5.5 9L3 6.5L3.705 5.795L5.5 7.585L9.295 3.79L10 4.5L5.5 9Z",
    fill: "#239F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckGreenCircle);
export default __webpack_public_path__ + "static/media/icn_check_green_circle.d9ea5af8d9c8b1730202f6c4e6e973b2.svg";
export { ForwardRef as ReactComponent };